import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAnalytics } from './lib/analytics';
// 実体は `src/styles/globalStyles.ts`。プリレンダーしたトップページと共用する。
import { globalStyles } from './styles/globalStyles';

// グローバルスタイルを注入
const styleElement = document.createElement('style');
styleElement.textContent = globalStyles;
document.head.appendChild(styleElement);

// アクセス解析（測定ID 未設定なら何もしない）。
// 初回 page_view は App 側の PageViewTracker が送るため、ここでは初期化のみ。
initAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker 登録（PWA）。
// 役割はアプリシェルのキャッシュだけで、API には一切介入しない（public/sw.js 参照）。
// 開発時は登録しない — 古いシェルを掴んで変更が反映されない事故を避けるため。
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      // 登録に失敗してもアプリは通常どおり動く（PWA 化されないだけ）
      console.error('Service Worker の登録に失敗しました:', error);
    });
  });
}